import React, { useState, memo, useEffect } from "react";
import "./PricingAnalysisPdf.css";
import { useNavigate, useLocation } from "react-router-dom";
import ArrowUp from "@mui/icons-material/ArrowUpward";
import ArrowDown from "@mui/icons-material/ArrowDownward";
import {
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
} from "@mui/material";
import InfiniteScroll from "react-infinite-scroller";
import { PriceConversion } from "../../Index";
import { capitalizeFirstLetter } from "../../../../helpers/dataHelper";
let profileArray = [];
let priceAnalysis = [];

const PricingAnalysisPdf = memo((props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [orderBy, setOrderBy] = useState("profileName");
  const [orderDirection, setOrderDirection] = useState(true);
  const [pricingData, setPricingData] = useState({});

  //pricing analysis table data from props
  useEffect(() => {
    if(props && props.data){
      setPricingData(props.data);
    }
  }, [props && props.data]);



  return (
    <div>
     <div
        className="season-table"
        
      >
          <Table className="table-design">
            <TableHead>
              <TableRow>
                <TableCell>
                  <span
                    className="hover-hand"
                    onClick={() => {
                      setOrderDirection(!orderDirection);
                      setOrderBy("profileName");
                    }}
                  >
                    Campgrounds {orderDirection ? <ArrowDown /> : <ArrowUp />}
                  </span>
                </TableCell>
                <TableCell></TableCell>
                <TableCell>RV Lot</TableCell>
                <TableCell>Camping/Tent Lot</TableCell>
                <TableCell>Cabin</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
            {props.avgPrice && props.avgPrice.length > 0 ? (
                props.avgPrice.map((data, i) => {
                    return (
                      <React.Fragment>
                        <TableRow key={data.priceper}>
                        { i == 0 ? (<TableCell
                            rowSpan={props.avgPrice.length}
                            className="profile-name"
                          >
                           Avg Market Price
                          </TableCell>) : ''}
                          <TableCell>{capitalizeFirstLetter(data.priceper)}</TableCell>
                          <TableCell>
                            {data.averagervsite ? <PriceConversion price={data.averagervsite} symbol={"$"}/>  : "-"}
                          </TableCell>
                          <TableCell>
                            {data.averagetent ? <PriceConversion price={data.averagetent} symbol={"$"}/> : "-"}
                          </TableCell>
                          <TableCell>
                            {data.averagecabin ? <PriceConversion price={data.averagecabin} symbol={"$"}/> : "-"}
                          </TableCell>
                        </TableRow>
                      </React.Fragment>
                    );
                  })
              ) : null}
              {pricingData && pricingData.length > 0 ? 
                pricingData.map((data) => {
                    return (
                      <React.Fragment>
                        <TableRow key={data[0].profileid}>
                          <TableCell
                            rowSpan={data.length}
                            className="profile-name"
                          >
                            {data[0].profilename}
                          </TableCell>
                          <TableCell>{capitalizeFirstLetter(data[0].priceper)}</TableCell>
                          <TableCell>
                            {data[0].rvsite ? data[0].rvsite : "-"}
                          </TableCell>
                          <TableCell>
                            {data[0].tent ? data[0].tent : "-"}
                          </TableCell>
                          <TableCell>
                            {data[0].cabin ? data[0].cabin : "-"}
                          </TableCell>
                        </TableRow>
                        {data.length > 2 ? (
                          <TableRow>
                            <TableCell>{capitalizeFirstLetter(data[2].priceper)}</TableCell>
                            <TableCell>
                              {data[2].rvsite ? data[2].rvsite : "-"}
                            </TableCell>
                            <TableCell>
                              {data[2].tent ? data[2].tent : "-"}
                            </TableCell>
                            <TableCell>
                              {data[2].cabin ? data[2].cabin : "-"}
                            </TableCell>
                          </TableRow>
                        ) : null}
                        {data.length > 1 ? (
                          <TableRow>
                            <TableCell>{capitalizeFirstLetter(data[1].priceper)}</TableCell>
                            <TableCell>
                              {data[1].rvsite ? data[1].rvsite : "-"}
                            </TableCell>
                            <TableCell>
                              {data[1].tent ? data[1].tent : "-"}
                            </TableCell>
                            <TableCell>
                              {data[1].cabin ? data[1].cabin : "-"}
                            </TableCell>
                          </TableRow>
                        ) : null}
                      </React.Fragment>
                    );
                })
               : (
                <TableRow>
                  <TableCell
                    colSpan={"5"}
                    style={{ textAlign: "center" }}
                    className="store-no-data"
                  >
                   No records found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
      </div>
    </div>
  );
});

export default PricingAnalysisPdf;
